<template>

  <div id="instrument-search">
    <div style="display:flex;margin-bottom: 10px;align-items: center;flex-wrap: wrap">
      <div
        v-for="(value,item,index) in searchList"
        :key="index">
        <div v-if="index < 3" style="margin-bottom: 10px;margin-right: 10px;">
          <div v-if="item === 'category'">
            <el-select
              v-model="searchList.category"
              size="small"
              placeholder="请选择商品目录">
              <el-option
                v-for="item in categoryOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div v-else-if="item.includes('At')">
            <el-date-picker
              v-model="searchList[item]"
              type="monthrange"
              size="small"
              unlink-panels
              :start-placeholder="keyToName[item]"
              :end-placeholder="keyToName[item]">
            </el-date-picker>
          </div>
          <!-- <el-select
            v-else-if="item === 'audit'"
            v-model="searchList.audit"
            size="small"
            placeholder="请选择审核状态">
            <el-option
              v-for="item in auditOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select> -->
          <el-select
            v-else-if="item === 'status'"
            v-model="searchList.status"
            size="small"
            placeholder="请选择是否上架">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input v-else v-model="searchList[item]" size="small" :placeholder="keyToName[item]" clearable></el-input>
        </div>

        <div  v-if="index >= 3">
          <div v-if="advanced" style="margin-bottom: 10px;margin-right: 10px;">
            <div>
              <div v-if="item === 'category'">
                <el-select
                  v-model="searchList.category"
                  size="small"
                  placeholder="请选择商品目录">
                  <el-option
                    v-for="item in categoryOptions"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div v-else-if="item.includes('At')">
                <el-date-picker
                  v-model="searchList[item]"
                  type="monthrange"
                  size="small"
                  unlink-panels
                  :start-placeholder="keyToName[item]"
                  :end-placeholder="keyToName[item]">
                </el-date-picker>
              </div>
              <el-select
                v-else-if="item === 'status'"
                v-model="searchList.status"
                size="small"
                placeholder="请选择是否上架">
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-input v-else-if="item === 'price'" size="small" v-model="searchList['price']" :placeholder="keyToName[item]" class="input-with-select">
                <el-select v-model="moneySelect" slot="prepend" placeholder="请选择" style="width: 100px;">
                  <el-option label="大于等于" value=">="></el-option>
                  <el-option label="小于等于" value="<="></el-option>
                  <el-option label="等于" value="="></el-option>
                </el-select>
              </el-input>
              <el-input v-else-if="item === 'stock'" size="small" v-model="searchList['stock']" :placeholder="keyToName[item]" class="input-with-select">
                <el-select v-model="stockSelect" slot="prepend" placeholder="请选择" style="width: 100px;">
                  <el-option label="大于等于" value=">="></el-option>
                  <el-option label="小于等于" value="<="></el-option>
                  <el-option label="等于" value="="></el-option>
                </el-select>
              </el-input>
              <el-input v-else v-model="searchList[item]" size="small" :placeholder="keyToName[item]" clearable></el-input>
            </div>
          </div>
        </div>
      </div>

      <div style="display:flex;margin-bottom: 10px;margin-right: 10px;align-items: center;">
        <div style="margin-left: 15px;">
          <el-button size="small" style="background-color: #324158;color: #eee" @click="doSearch">查询</el-button>
        </div>
        <div style="margin-left: 10px;">
          <el-button size="small" style="background-color: #324158;color: #eee" @click="reset">重置</el-button>
        </div>
        <div v-if="type === 'products'" style="margin-left: 20px;">
          <el-button size="small" style="background-color: #324158;color: #eee" @click="searchCategory">查询已有大类</el-button>
        </div>
        <div v-if="type === 'category' || type === 'products'" style="margin-left: 20px;">
          <el-button size="small" style="background-color: #324158;color: #eee" @click="generateCategory">创建大类</el-button>
        </div>
        <div v-if="type === 'batch'" style="margin-left: 20px;">
          <el-button size="small" style="background-color: #324158;color: #eee" @click="generateBatch">创建批次</el-button>
        </div>
        <div v-if="type === 'coupon'" style="margin-left: 20px;">
          <el-button size="small" style="background-color: #324158;color: #eee" @click="generateCoupon">创建优惠券</el-button>
        </div>
        <div v-if="type === 'nfc'" style="margin-left: 20px;">
          <el-button size="small" style="background-color: #324158;color: #eee" @click="generateNFC">创建文件夹</el-button>
        </div>

        <div style="margin-left: 20px;" >
          <a @click="toggleAdvanced" style="margin: 0 4px 0 8px;vertical-align: middle;cursor: pointer;font-size: 14px;">
            {{advanced ? '收起' : '展开'}}
            <i :class="advanced ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </a>
        </div>
      </div>
    </div>

    <c-dialog :dialogVisible="createBatchDialogVisible" @change-state="changeDialogState" ></c-dialog>
    <coupon-dialog :dialogVisible="createCouponDialogVisible" @change-state="changeCouponDialogState"></coupon-dialog>
    <group-dialog :dialogVisible="createGroupDialogVisible" @change-state="changeGroupDialogState"></group-dialog>
    <category :dialogVisible="searchCategoryDialogVisible" @change-state="changeSearchCategoryDialogState"></category>
    <create-category :dialogVisible="createCategoryDialogVisible" @change-state="changeCategoryDialogState"></create-category>
  </div>
</template>

<script>
import createBatchDialog from "@/components/dialog/CreateBatchDialog.vue";
import createCouponDialog from "@/components/dialog/CreateCouponDialog.vue";
import createGroupDialog from "@/components/dialog/CreateGroupDialog.vue";
import searchCategoryDialog from "@/components/dialog/SearchCategoryDialog.vue";
import createCategoryDialog from "@/components/dialog/CreateCategoryDialog.vue";
export default {
  name: 'instrument-search',
  props:['searchList','type','newKeyToName'],
  components: {
    'c-dialog': createBatchDialog,
    'coupon-dialog': createCouponDialog,
    'group-dialog':createGroupDialog,
    'category': searchCategoryDialog,
    'create-category': createCategoryDialog
  },
  data() {
    return {
      advanced: false,
      keyToName: this.$commondata.KEY_TO_NAME,
      statusOptions: [
        {name: '上架&下架',value: '',},
        {name: '上架',value: 'on',},
        {name: '下架',value: 'off',},
      ],
      categoryOptions: [
        {name: '全部商品目录',value: ''},
        {name: '电子产品',value: '电子产品'},
        {name: '生活用品',value: '生活用品'},
      ],
      auditOptions: [
        {name: '全部审核',value: '',},
        {name: '借出审核',value: '借出审核中'},
        {name: '归还审核',value: '归还审核中'},
      ],
      departMentList: [],
      moneySelect: '>=',
      stockSelect: '>=',

      createBatchDialogVisible: false,
      createCouponDialogVisible: false,
      createGroupDialogVisible: false,
      searchCategoryDialogVisible: false,
      createCategoryDialogVisible: false,
    }
  },
  async mounted(){
    if(this.searchList && this.searchList['departmentId'] !== undefined)
      this.departMentList = await this.$equipmentdata.getDepartMentList({});
    this.keyToName = this.newKeyToName ? this.newKeyToName : this.keyToName;
  },
  methods: {
    doSearch(){
      let price = '';
      let stock = '';
      if(this.searchList.price){
        if(this.moneySelect === '>=') price = { $gte: this.searchList.price }
        if(this.moneySelect === '<=') price = { $lte: this.searchList.price }
        if(this.moneySelect === '=') price = { $eq: this.searchList.price }
        //price = this.moneySelect + "'" + this.searchList.price + "'"
      }
      if(this.searchList.stock){
        if(this.moneySelect === '>=') stock = { $gte: this.searchList.stock }
        if(this.moneySelect === '<=') stock = { $lte: this.searchList.stock }
        if(this.moneySelect === '=') stock = { $eq: this.searchList.stock }
        //stock = this.moneySelect + "'" + this.searchList.stock + "'"
      }
      //this.$commondata.searchObj = this.searchList;
      this.$emit('onSearch',{price,stock})
    },

    reset(){
      for(let item in this.searchList){
        this.searchList[item] = '';
      }
    },

    toggleAdvanced(){
      this.advanced = !this.advanced;
    },

    generateBatch(){
      this.createBatchDialogVisible = true;
    },

    generateCoupon(){
      this.createCouponDialogVisible = true;
    },

    generateNFC(){
      this.createGroupDialogVisible = true
    },

    changeDialogState(val){
      if(val.refresh) {
        this.$emit('onSearch')
      }
      this.createBatchDialogVisible = val.isShow;
    },

    changeCouponDialogState(val){
      if(val.refresh) {
        this.$emit('onSearch')
      }
      this.createCouponDialogVisible = val.isShow;
    },

    changeGroupDialogState(val){
      if(val.refresh) {
        this.$emit('onSearch')
      }
      this.createGroupDialogVisible = val.isShow;
    },

    searchCategory(){
      this.searchCategoryDialogVisible = true;
    },

    changeSearchCategoryDialogState(val){
      this.searchCategoryDialogVisible = val.isShow;
    },

    generateCategory(){
      this.createCategoryDialogVisible = true
    },

    changeCategoryDialogState(val){
      console.log(val);
      if(val.refresh) {
        this.$emit('onSearch')
      }
      this.createCategoryDialogVisible = val.isShow;
    }
  }
}
</script>
<style>
html,body{
  margin: 0;
  height: 100%;
}
#instrument-search{
  position: relative;
  height: 100%;
}
.input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/instrument/SearchComponent.vue